function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#D63C32",
  fillRule: "evenodd",
  d: "M11.91 13.136l3.56 3.56a.867.867 0 0 0 1.226-1.226l-3.56-3.56 3.56-3.56a.867.867 0 1 0-1.226-1.226l-3.56 3.56-3.56-3.56a.867.867 0 0 0-1.226 1.225l3.56 3.56-3.56 3.561a.867.867 0 0 0 1.225 1.226l3.56-3.56zm-8.395-9.65c4.676-4.677 12.294-4.677 16.97 0 4.677 4.676 4.697 12.273 0 16.97-4.676 4.677-12.294 4.677-16.97 0-4.677-4.677-4.677-12.294 0-16.97z"
});

const SvgFail = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFail, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/fail.c49c67aa.svg";
export { ForwardRef as ReactComponent };